// Tüm console çıktılarını tamamen devre dışı bırak
(() => {
    // Boş fonksiyon
    const noop = () => {};

    // Production ve development ortamında tüm logları kapat
    try {
        // Console metodlarını tamamen boş fonksiyonlarla değiştir
        const disabledConsole = {
            assert: noop,
            clear: noop,
            count: noop,
            countReset: noop,
            debug: noop,
            dir: noop,
            dirxml: noop,
            error: noop,
            group: noop,
            groupCollapsed: noop,
            groupEnd: noop,
            info: noop,
            log: noop,
            profile: noop,
            profileEnd: noop,
            table: noop,
            time: noop,
            timeEnd: noop,
            timeLog: noop,
            timeStamp: noop,
            trace: noop,
            warn: noop,
            // Console'un tüm metodlarını kapat
            Console: function() {}
        };

        // Console objesini değiştirilemez yap
        Object.defineProperty(window, 'console', {
            get: () => disabledConsole,
            configurable: false
        });

        // Firebase ve diğer debug modlarını kapat
        // @ts-ignore
        window.FIREBASE_APPCHECK_DEBUG_TOKEN = false;
        // @ts-ignore
        window.FIREBASE_DEBUG_MODE = false;
        // @ts-ignore
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = { isDisabled: true };
        // @ts-ignore
        window.debugLevel = 0;

        // Ek olarak global error handler'ı da sustur
        window.onerror = noop;
        window.onunhandledrejection = noop;

    } catch (e) {
        // Hata durumunda bile sessiz kal
    }
})();

// Modül olarak dışa aktar (geriye dönük uyumluluk için)
export default () => {}; 